import { fleetApi } from '../../api/axiosClient';
import { timezone } from '../../utils/timeZone';

const getTzParam = (tz) => {
  const defaultTz = typeof timezone === 'function' ? timezone() : Number(timezone);
  const activeTz =
    tz !== undefined && tz !== null && !isNaN(tz)
      ? Number(tz)
      : !isNaN(defaultTz)
        ? defaultTz
        : Math.abs(new Date().getTimezoneOffset() / 60);
  return `?tz=${activeTz}`;
};

export const filterReportFuelSummary = async (payload, tz) => {
  try {
    const activeTz = tz ?? payload?.tz;
    const response = await fleetApi.post(`/report-fuel-summary${getTzParam(activeTz)}&withoutLogicAllSensor=true`, payload);
    return response;
  } catch (error) {
    console.error('Error fetching fuel summary report:', error);
    throw error;
  }
};

const timeToSeconds = (timeStr) => {
  if (!timeStr || typeof timeStr !== 'string') return 0;
  const parts = timeStr.split(':').map(Number);
  let h = 0,
    m = 0,
    s = 0;

  if (parts.length === 3) {
    [h, m, s] = parts;
  } else if (parts.length === 2) {
    [h, m] = parts;
  }
  return h * 3600 + m * 60 + s;
};
const secondsToVerboseFormat = (totalSeconds) => {
  if (!totalSeconds) return '0 Hours 00 Minutes 00 Seconds';

  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = Math.round(totalSeconds % 60);

  const pad = (num) => num.toString().padStart(2, '0');
  return `${h} Hours ${pad(m)} Minutes ${pad(s)} Seconds`;
};

export const fuelConsumptionCount = (data) => {
  const total = data.reduce((acc, curr) => {
    const usage = Number(curr.total_bbm_usage) || 0;
    const usageCanbus = Number(curr.total_bbm_usage_canbus) || 0;
    const val = usage > 0 ? usage : usageCanbus;
    return acc + val;
  }, 0);
  return total.toFixed(2);
};

export const fuelConsumptionCanbusCount = (data) => {
  const total = data.reduce((acc, curr) => {
    return acc + (Number(curr.total_fuel_consumed_canbus) || 0);
  }, 0);
  return total.toFixed(2);
};

export const fillVolumeCount = (data) => {
  const total = data.reduce((grandTotal, curr) => {
    const fuels = Array.isArray(curr.calculate_fuel) ? curr.calculate_fuel : [];
    const rowRefuelTotal = fuels.reduce((subTotal, item) => {
      return subTotal + (Number(item.rest_fuel_level) || 0);
    }, 0);
    return grandTotal + rowRefuelTotal;
  }, 0);
  return `${total.toFixed(2)}`;
};

export const residualVolumeCount = (data) => {
  const total = data.reduce((acc, curr) => {
    const fuels = Array.isArray(curr.calculate_fuel) ? curr.calculate_fuel : [];
    if (fuels.length > 0) {
      const lastItem = fuels[fuels.length - 1];
      const endLevel = Number(lastItem.end_fuel_level) || 0;
      return acc + endLevel;
    }
    return acc;
  }, 0);

  return `${total.toFixed(2)}`;
};

export const totalDistanceCount = (data) => {
  const total = data.reduce((acc, curr) => {
    return acc + (Number(curr.distance) || 0);
  }, 0);
  return `${total.toFixed(2)}`;
};
export const totalDurationOnCount = (data) => {
  const totalSeconds = data.reduce((acc, curr) => {
    return acc + timeToSeconds(curr.total_engine_on);
  }, 0);
  return secondsToVerboseFormat(totalSeconds);
};

export const totalDurationOffCount = (data) => {
  const totalSeconds = data.reduce((acc, curr) => {
    return acc + timeToSeconds(curr.idle_time);
  }, 0);
  return secondsToVerboseFormat(totalSeconds);
};

export const datePickerStyle = {
  '& .MuiInputLabel-root': {
    color: '#485D9A',
    '&.Mui-focused': { color: '#485D9A' }
  },
  '& .MuiOutlinedInput-root': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#485D9A'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#485D9A'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#485D9A'
    }
  }
};
export const readOnlyFieldStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    minWidth: 400,
    '& fieldset': { borderColor: '#485D9A' },
    '&:hover fieldset': { borderColor: '#485D9A' },
    '&.Mui-focused fieldset': { borderColor: '#485D9A' }
  },
  '& .MuiInputLabel-root.Mui-focused': { color: '#485D9A' }
};
